import React, { ReactNode } from "react";
import { FontSize } from "../../Constants/Enums/Size.enums";
import { Colors } from "../../Constants/colors";
import { Modal, ModalSize } from ".";
import { BtnType } from "../Button";
import deleteIcon from "./../../images/delete.svg";

interface Props {
  title?: string;
  children: ReactNode;
  show: boolean;
  onClose: () => unknown;
  onSubmit: () => unknown;
  isRemoving?: boolean;
  isProcessingConfirmation?: boolean;
  submitButtonText?: string;
}
export const ConfirmationModalContainer = ({
  title = "Are you sure ?",
  show,
  children,
  onClose,
  onSubmit,
  isRemoving = false,
  isProcessingConfirmation = false,
  submitButtonText = "Remove",
}: Props) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      submissionButton={{
        text: submitButtonText,
        onClick: () => {
          onSubmit();
        },
        buttonType: BtnType.primary,
        isSubmitLoading: isProcessingConfirmation,
      }}
      modalSize={ModalSize.xs}
      requiresCloseIcon={false}
    >
      <div className="flex flex-col justify-center items-center gap-2">
        {isRemoving ? (
          <img
            src={deleteIcon}
            alt="Remove"
            style={{ height: "80px", width: "80px" }}
          />
        ) : (
          // <Lottie
          //   options={{
          //     animationData: dustbinAnimation,
          //     loop: false,
          //   }}
          //   // isPaused={true}
          //   height={200}
          //   width={"100%"}
          //   style={{
          //     padding: 0,
          //     transform: "scale(0.8)",
          //     transformOrigin: "center",
          //   }}
          // />
          <div />
        )}

        <div style={{ fontSize: FontSize.F24, color: Colors.Black }}>
          {title}
        </div>
        <div
          className="flex justify-center items-center flex-col gap-4"
          style={{
            textAlign: "center",
            fontSize: FontSize.F16,
            color: Colors.Grey,
          }}
        >
          {children}
        </div>
      </div>
    </Modal>
  );
};
